import { useState } from "react";
import logo from "../assets/brand/logo.png";
import ConfirmLogout from "./confirmLogout";

const Header = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  return (
    <header
      style={{
        width: "100%",
        // background: "rgb(255,208,115)",
        background:
          "linear-gradient(270deg, rgba(255,208,115,1) 25%, rgba(213,162,62,1) 50%, rgba(179,130,36,1) 75%)",
        height: "50px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <img src={logo} alt="logo" height={40} />
      <button
        className=" btn btn-danger "
        onClick={() => {
          setShowLogoutModal(true);
        }}
      >
        Logout
      </button>
      {showLogoutModal && (
        <ConfirmLogout onClose={() => setShowLogoutModal(false)} />
      )}
    </header>
  );
};

export default Header;
